import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import VueTelInput from 'vue-tel-input'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: String
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: String
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps,
      wrapperClasses: 'customTelMaterial',
      showError: false
    }
  },
  created () {},
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {},
    // eslint-disable-next-line no-unused-vars
    onInput ({ number, isValid, country }) {
      if(this.config.validation) {
        this.wrapperClasses = !isValid ? 'customTelMaterial error' : 'customTelMaterial'
        this.showError = !isValid
      } 
    },
    onSubmitEvent (payload) {
      if(this.config.validation) {
        this.wrapperClasses = !payload ? 'customTelMaterial error' : 'customTelMaterial'
        this.showError = !payload
      }
    },
    validate () {
      this.$refs[this._uid].$emit('submitEvent', this.value)
    }
  },
  components: {
    VueTelInput
  }
}
